export default __webpack_public_path__ + "static/media/szkocja.53f20880.jpg";